import styled from 'styled-components';

export const GoToSignInContainer = styled.div`
  margin-top: 32px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  > div {
    max-width: 345px;
    text-align: center;
  }
`;

export const GoToSignInButton = styled.button`
  text-decoration: underline;
  text-align: center;
`;
